var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMylogoTemplateBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "203px",
    height: "159px",
    viewBox: "0 0 203 159",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 0,
    x2: 120,
    y2: 43,
    id: "gradient_1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#6FC0EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2469AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 0,
    x2: 70,
    y2: 159,
    id: "gradient_2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#6FC0EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2469AF"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L120 0L120 43L0 43L0 0Z",
    id: "Rectangle",
    fill: "url(#gradient_1)",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 58L120 58L120 101L0 101L0 58Z",
    id: "Rectangle-Copy",
    fill: "url(#gradient_1)",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 116L120 116L120 159L0 159L0 116Z",
    id: "Rectangle-Copy-2",
    fill: "url(#gradient_1)",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133 0L203 0L203 159L133 159L133 0Z",
    id: "Rectangle-3",
    fill: "url(#gradient_2)",
    fillRule: "evenodd",
    stroke: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMylogoTemplateBlue);
export default __webpack_public_path__ + "static/media/mylogo-template_blue.ac1d508e85e500050003ed889370b5c5.svg";
export { ForwardRef as ReactComponent };